var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"client-cashback-list"},_vm._l((_vm.cashback),function(cashbackItem){return _c('ClientCashbackListItem',{key:cashbackItem.id,staticClass:"client-cashback-item",class:{
      valid: cashbackItem.isValid,
      'not-valid-yet': cashbackItem.notValidYet,
    },attrs:{"id":cashbackItem.id,"cashbackItem":cashbackItem},on:{"doubleCashback":_vm.doubleCashback}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }